export default "__VITE_ASSET__BizcXHHH__"